import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">
                就要草视频
              </span>
            </div>
            <p className="text-sm text-secondary-400 leading-relaxed">
              精选视频内容平台，汇聚海量精彩视频资源，为您提供流畅、便捷的在线视频观看体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              视频分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  帮助中心
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  用户协议
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              关注我们
            </h4>
            <div className="flex items-center gap-3 mb-4">
              <a
                href="https://weibo.com/jiuyaocao"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-secondary-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="https://space.bilibili.com/jiuyaocao"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-secondary-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-bilibili-line"></i>
              </a>
              <a
                href="https://www.douyin.com/user/jiuyaocao"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-secondary-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-tiktok-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-secondary-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-wechat-line"></i>
              </a>
            </div>
            <p className="text-xs text-secondary-500">
              客服邮箱：contact@jiuyaocao.com
            </p>
            <p className="text-xs text-secondary-500 mt-1">
              客服电话：400-888-6666
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-500">
            &copy; 2020-2026 就要草视频 jiuyaocao.com 版权所有
          </p>
          <p className="text-xs text-secondary-500">
            <a
              href="#"
              className="hover:text-accent-400 transition-colors cursor-pointer"
              rel="nofollow"
            >
              京ICP备2020XXXXXXXX号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}